import { Component, Input, OnInit, OnChanges, Output, EventEmitter, SimpleChanges, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UserDataService } from '../../services/user-data.service';
import {NewMessageService} from "../../services/newMessage/new-message.service";
import {FormBuilder} from "@angular/forms";
import { Subscription } from 'rxjs';
import { AdGroupSuggestion } from '../../model/LoginUserInfo/AdUserSuggestion';
import { Module } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-contact-search',
    templateUrl: './contact-search.component.html',
    styleUrls: ['./contact-search.component.scss']
})
export class ContactSearchComponent implements OnInit, OnChanges, OnDestroy {
    @Input() displayContactSearchModal = false;
    @Input() allToCcDBUser: any[];
    @Input() isClosed = true;
    @Input() popup: string;
    @Output() pushToTo = new EventEmitter();
    @Output() loadCmc = new EventEmitter();
    @Output() modalVisibilityChange = new EventEmitter<boolean>();
    private searchDebounceTimer: any;
    public modules: Module[] = [ClientSideRowModelModule];
    private _searchByOption: 'USER' | 'GROUP' = 'USER';

    public get searchByOption(): 'USER' | 'GROUP' {
        return this._searchByOption;
    }

    public set searchByOption(value: 'USER' | 'GROUP') {
        // checking if the value is actually changing to avoid unnecessary resets
        if (this._searchByOption !== value) {
            // clear the search results and reset state
            this.routesList = [];
            this.search = false;
            this.errorMsg = '';
        }
        this._searchByOption = value;
    }

    // for AD search
    isAutoCompleteDisabled: boolean = false;
    active_directory_available_for_suggestions: boolean = environment.ACTIVE_DIRECTORY_AVAILABLE_FOR_SUGGESTIONS;
    private loggedInUserInfoSubscription: Subscription;
    searchPerformed = false;

    constructor(
        private readonly userDataService: UserDataService,
        private readonly newMessageService: NewMessageService,
        private readonly builder: FormBuilder,
        private readonly cdRef: ChangeDetectorRef
    ) { }

    public gridApiInquiry;
    public routesColumn: any = [];
    query = '';
    filteredItems: Array<any> = [];
    isAdvancedSearch = false;
    public routesList: any = [];
    public soeId = '';
    public errorMsg = '';
    loginUserInfo: any;
    public toCcBcc = '';
    public search = false;
    showCmcSpinner = false;
    public displayError = false;
    public defaultColDef;
    public gridColumnApiInquiry;
    public lbTotalRecords = 0;
    public lbPageSize = 0;
    public lbCurrentPage = 0;
    public lbTotalPages = 0;
    public disablePaginationNextLast = false;
    public disablePaginationPrevFirst = false;


    advancedSearch = {
        // clientIdentifier: '', // Do not remove
        // clientIdentifierValue: '', // Do not remove
        firstName: '',
        lastName: '',
        email: '',
        groupDL: ''
    };

    get toggleSearch(): boolean {
        return this.displayContactSearchModal;
    }

    set toggleSearch(value: boolean) {
        this.displayContactSearchModal = value;
        this.modalVisibilityChange.emit(value);
    }

    showHideContactSearch(): void {
        this.onDialogHide(); // Reuse the same cleanup logic
    }

    onPageInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const newPage = parseInt(input.value);

        // Validate the input
        if (newPage && newPage >= 1 && newPage <= this.lbTotalPages) {
            // AG-Grid pages are 0-based
            this.gridApiInquiry.paginationGoToPage(newPage - 1);
        } else {
            // Reset to current page if invalid input
            input.value = this.lbCurrentPage.toString();
        }
    }

    onPaginationChanged() {
        if (this.gridApiInquiry) {
            this.lbTotalRecords = this.gridApiInquiry.paginationGetRowCount();
            this.lbPageSize = this.gridApiInquiry.paginationGetPageSize();
            this.lbCurrentPage = this.gridApiInquiry.paginationGetCurrentPage() + 1;
            this.lbTotalPages = this.gridApiInquiry.paginationGetTotalPages();

            const currentPage = this.gridApiInquiry.paginationGetCurrentPage() + 1;
            const lastPage = this.gridApiInquiry.paginationGetTotalPages();

            this.disablePaginationNextLast = currentPage === lastPage;
            this.disablePaginationPrevFirst = currentPage === 1;

            if (this.lbPageSize > this.lbTotalRecords) {
                this.lbPageSize = this.lbTotalRecords;
            }
        }
    }

    onBtNext() {
        this.gridApiInquiry.paginationGoToNextPage();
    }
    onBtPrevious() {
        this.gridApiInquiry.paginationGoToPreviousPage();
    }
    onBtLast() {
        this.gridApiInquiry.paginationGoToLastPage();
    }
    onBtFirst() {
        this.gridApiInquiry.paginationGoToFirstPage();
    }

    resetAdvancedSearch() {
        // Reset advanced search form
        this.advancedSearch = {
            // clientIdentifier: '', // Do not remove
            // clientIdentifierValue: '', // Do not remove
            firstName: '',
            lastName: '',
            email: '',
            groupDL: ''
        };

        // Reset grid and search related properties
        this.routesList = [];
        this.search = false;
        this.errorMsg = '';

        // Clear grid if it exists
        if (this.gridApiInquiry) {
            this.gridApiInquiry.rowData = [];
        }
    }

    ngOnInit(): void {
        if (this.loggedInUserInfoSubscription) {
            this.loggedInUserInfoSubscription.unsubscribe();
        }

        this.loggedInUserInfoSubscription = this.userDataService.LocalGetLoginUserInfo().subscribe(loginUserInfo => {
            if (loginUserInfo) {
                this.loginUserInfo = loginUserInfo;
                this.soeId = loginUserInfo.userId;
                this.isAutoCompleteDisabled = loginUserInfo?.disableAutoComplete ?? false;
                this.cdRef.markForCheck();
            }
        });

        this.createRouteColumn();
    }

    ngOnDestroy(): void {
        this.searchPerformed = false;
        this.query = '';
        this.filteredItems = [];
        
        if (this.loggedInUserInfoSubscription) {
            this.loggedInUserInfoSubscription.unsubscribe();
        }
    }

    private createRouteColumn() {

        this.defaultColDef = {
            resizable: true,
            suppressMovable: true,
            sortable: true,
            cellStyle: { 'background-color': 'white', 'color': '#002d72' },
            menuTabs: ["filterMenuTab"],
        };

        this.routesColumn = [
            {
                field: "contactName",
                headerName: 'Name',
                width: 200,
                headerCheckboxSelection: true,
                checkboxSelection: true,
                tooltipField: "contactName"
            },
            {
                field: "contactEmail",
                headerName: 'Email ID',
                width: 250,
                tooltipField: "contactEmail",
                autoSizeColumns: true
            },
            {
                field: "clientName",
                headerName: 'Client Name',
                width: 200,
                tooltipField: "clientName"
            },
            {
                field: "clientId",
                headerName: 'Client ID',
                width: 120,
                tooltipField: "clientId"
            },
            {
                field: "clientIdType",
                headerName: 'Client Type',
                width: 120,
                tooltipField: "clientIdType"
            },
            {
                field: "taxId",
                headerName: 'Tax ID',
                width: 120,
                tooltipField: "taxId"
            },
            {
                field: "managementId",
                headerName: 'Mgmt ID',
                width: 120,
                tooltipField: "managementId"
            },
            {
                field: "mnemonic",
                headerName: 'Mnemonic',
                width: 150,
                tooltipField: "mnemonic"
            },
            {
                field: "department",
                headerName: 'Dept',
                width: 120,
                tooltipField: "department"
            }
        ];

        // this.rowSelection = "multiple";
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.displayContactSearchModal) {
            this.toggleSearch = this.displayContactSearchModal;
        }
    }

/*
    ngOnChanges(changes: SimpleChanges): void {
        console.log('Contact Search Changes:', changes);
        if (changes.allToCcDBUser && changes.allToCcDBUser.currentValue) {
            console.log('All Users:', changes.allToCcDBUser.currentValue);
            this.assignCopy();
        }
        if (changes.displayContactSearchModal) {
            this.toggleSearch = this.displayContactSearchModal;
        }
    }
*/

/*
    filterItem(value){
        if (!value){
            this.assignCopy();
        }
        if (value.trim() === '') {
            this.filteredItems = [];
            return;
        }

        // Sample data - replace this with your actual data
        const sampleItems = [
            { name: 'John Doe', value: 'john.doe@deltacapita.com', id: 'john.doe' },
            { name: 'Jane Smith', value: 'jane.smith@deltacapita.com', id: 'jane.smith' },
            { name: 'Mike Johnson', value: 'mike.johnson@deltacapita.com', id: 'mike.johnson' },
            { name: 'Sarah Williams', value: 'sarah.williams@deltacapita.com', id: 'sarah.williams' },
            { name: 'Unnikrishnan Vasudevan', value: 'unnikrishnan.vasudevan@ext.deltacapita.com', id: 'unnikrishnan.vasudevan' },
            { name: 'Robert Brown', value: 'robert.brown@deltacapita.com', id: 'robert.brown' }
        ];

        this.filteredItems = sampleItems.filter(item =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.value.toLowerCase().includes(value.toLowerCase()) ||
            item.id.toLowerCase().includes(value.toLowerCase())
        );
    }
*/

    filterItem(value: string) {
        clearTimeout(this.searchDebounceTimer);
        const DEBOUNCE_DELAY_MS = 250; // 250ms
        const MIN_AD_SEARCH_LENGTH = 3; // Minimum length for AD search

        this.searchDebounceTimer = setTimeout(async () => {
            const query = value.trim();
            // clear results and stop if the query is empty or too short
            if (!query || query.length < MIN_AD_SEARCH_LENGTH) {
                this.filteredItems = [];
                this.searchPerformed = false;
                this.cdRef.detectChanges();
                return;
            }

            this.searchPerformed = true;
            // always perform local search
            const localSuggestions = (this.allToCcDBUser || []).filter(
                item => item.value.toLowerCase().indexOf(query.toLowerCase()) > -1
            );

            let allAdSuggestions: any[] = [];
            // if (this.active_directory_available_for_suggestions) {
            //     // make 3 parallel calls
            //     const [usersByDisplayName, usersByEmail, groupsByDl] = await Promise.all([
            //         this.userDataService.getAdSearchUserList({ displayName: query }, this.loginUserInfo.citiDomainList || []).catch(e => { console.error(e); return []; }),
            //         this.userDataService.getAdSearchUserList({ email: query }, this.loginUserInfo.citiDomainList || []).catch(e => { console.error(e); return []; }),
            //         this.userDataService.getAdSearchGroupList({ displayName: query }).catch(e => { console.error(e); return []; })
            //     ]);

            //     // map AD User results
            //     const adUserSuggestions = [...(usersByDisplayName || []), ...(usersByEmail || [])].map(user => ({
            //         text: user.displayName,
            //         value: user.mail,
            //         id: (user.mail && user.mail !== 'null') ? user.mail : user.userPrincipalName,
            //     }));

            //     // map AD Group results
            //     const adGroupSuggestions = (groupsByDl || []).map((group: AdGroupSuggestion) => ({
            //         text: group.displayName,
            //         value: group.mail,
            //         id: group.id,
            //     }));

            //     allAdSuggestions = [...adUserSuggestions, ...adGroupSuggestions];
            // }

            // combine and de-duplicate all results
            const combinedSuggestions = [...localSuggestions, ...allAdSuggestions];
            const uniqueSuggestionsMap = new Map<string, any>();

            combinedSuggestions.forEach(suggestion => {
                if (suggestion?.value) {
                    const normalizedKey = String(suggestion.value).toLowerCase();
                    if (!uniqueSuggestionsMap.has(normalizedKey)) {
                        uniqueSuggestionsMap.set(normalizedKey, suggestion);
                    }
                }
            });

            this.filteredItems = Array.from(uniqueSuggestionsMap.values());
            this.cdRef.detectChanges();

        }, DEBOUNCE_DELAY_MS);
    }


    selectItem(item: any): void {
        this.pushToTo.emit(item);
        this.query = ''; // Clear the input
        this.filteredItems = []; // Clear suggestions
        this.displayContactSearchModal = false; // Close the modal
        this.modalVisibilityChange.emit(false);
    }

    selectCMSContacts() {
        const selectedRows = this.gridApiInquiry.getSelectedRows();
        const selectedContacts = [];
        selectedRows.forEach(row => {
            // selectedContacts.push({ text: row.contactName, value: row.contactEmail });
            this.pushToTo.emit({ text: row.contactName, value: row.contactEmail, email: row.contactEmail, toCcBcc: this.toCcBcc
        });
        });
        // this.pushToTo.emit({ selectedContacts, toCcBcc: this.toCcBcc });
        this.query = ''; // Clear the input
        this.filteredItems = []; // Clear suggestions
        this.displayContactSearchModal = false; // Close the modal
        this.modalVisibilityChange.emit(false);
    }

    assignCopy(): void {
        console.log('Assigning Copy - allToCcDBUser:', this.allToCcDBUser);
        if (this.allToCcDBUser && this.allToCcDBUser.length > 0) {
            this.filteredItems = Object.assign([], this.allToCcDBUser);
        }
    }

    // Add type for submit handling
    onSubmit(): void {
        if (this.filteredItems.length > 0) {
            this.pushToTo.emit(this.filteredItems[0]);
            this.showHideContactSearch();
        }
    }

    onDialogHide(): void {
        // Reset the search text and filtered items
        this.toggleSearch = false;
        this.query = '';
        this.filteredItems = [];
        this.modalVisibilityChange.emit(false);
        this.isAdvancedSearch = false;

        // Clear advanced search form
        this.advancedSearch = {
            // clientIdentifier: '', // Do not remove
            // clientIdentifierValue: '', // Do not remove
            firstName: '',
            lastName: '',
            email: '',
            groupDL: ''
        };

        // Clear grid data and search results
        this.routesList = [];
        this.search = false;
        this.errorMsg = '';
        this.displayError = false;
    }

    callCmcSearchWindow(): void {
        this.isAdvancedSearch = true;
    }

    backToGeneralSearch(): void {
        this.isAdvancedSearch = false;
    }

    // Null value check function
    isNull(input) {
        if (input === "" || input === undefined || input == null) {
            return true;
        }
        return false;
    }

    validateCMC() {
        const firstName = this.advancedSearch.firstName;
        const lastName = this.advancedSearch.lastName;
        const contactEmail = this.advancedSearch.email;
        const groupDL = this.advancedSearch.groupDL;
        // const clientIdentifierOption = this.advancedSearch.clientIdentifier; // Do not remove
        // const clientIdentifierValue = this.advancedSearch.clientIdentifierValue; // Do not remove

        const regexFirstName = /^[A-Za-z ]+$/.test(firstName);
        const regexLastName = /^[A-Za-z ]+$/.test(lastName);
        const regexGroupDL = /^[A-Za-z0-9]+$/.test(groupDL);
        // const regexGpId = /^[0-9]*$/.test(clientIdentifierValue);  // Do not remove
        const regexEmail = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/.test(contactEmail);

        // Do not remove
        // if (!this.isNull(clientIdentifierOption) && this.isNull(clientIdentifierValue)) {
        //     this.errorMsg = 'Enter valid selected Client Identifier';
        //     return true;
        // }
        // else if (!regexFirstName && !this.isNull(firstName)) {
        if (!regexFirstName && !this.isNull(firstName)) {
            this.errorMsg = 'Enter first name with characters from a-zA-Z';
            return true;
        }
        else if (!regexLastName && !this.isNull(lastName)) {
            this.errorMsg = 'Enter last name with characters from a-zA-Z';
            return true;
        }
        // Do not remove
        // else if (!regexGpId && (clientIdentifierOption === "GP ID")) {
        //     this.errorMsg = 'Enter gp id with numbers only';
        //     return true;
        // }
        else if (!regexEmail && !this.isNull(contactEmail)) {
            this.errorMsg = 'Enter valid email id';
            return true;
        }
        else if (!regexGroupDL && !this.isNull(groupDL)) {
            this.errorMsg = 'Enter valid Group DL';
            return true;
        }
        else if (this.isNull(firstName) && this.isNull(lastName) && this.isNull(contactEmail) && this.isNull(groupDL)) {
            // && this.isNull(clientIdentifierOption) && this.isNull(clientIdentifierValue)) { // Do not remove
            this.errorMsg = 'Enter valid search criteria';
            return true;
        }

        // Do not remove
        // // If select clientIdentifierOption is blank and clientIdentifierValue was value entered, reset the value field
        // if (this.isNull(clientIdentifierOption) && !this.isNull(clientIdentifierValue)) {
        //     this.advancedSearch.clientIdentifierValue = '';
        // }
        return false;
    }

    public gridOptions = {
        pagination: true,
        paginationPageSize: 10, // Set default page size to 10 rows
        //paginationPageSizeSelector: [10, 25, 50, 100], // Allow users to choose from these page sizes
        suppressPaginationPanel: true, // We're using custom pagination controls
    };

    onGridReadyInquiry(params) {
        this.gridApiInquiry = params.api;
        this.gridColumnApiInquiry = params.columnApi;

        // If we already have data, set it
        if (this.routesList.length > 0) {
            this.showCmcSpinner = false;
        }

        params.api.sizeColumnsToFit();
        this.onPaginationChanged();
    }

    searchCMC() {
        this.showCmcSpinner = true;
        this.routesList = [];
        this.search = false;
        this.errorMsg = '';
        this.displayError = false;
    
        // User Search Logic (Local + CMC + Active Directory)
        if (this.searchByOption === 'USER') {
            if (this.validateCMC()) {
                this.displayError = true;
                this.showCmcSpinner = false;
                return false;
            } else {
                this.errorMsg = '';
            }

            const searchParams = {
                searchType: 'advanced',
                // Do not remove
                // clientIdentifier: {
                //     type: this.advancedSearch.clientIdentifier,
                //     value: this.advancedSearch.clientIdentifierValue
                // },
                firstName: this.advancedSearch.firstName,
                lastName: this.advancedSearch.lastName,
                email: this.advancedSearch.email
            };
    
            // Get matching local suggestions for users
            const localSuggestions = (this.allToCcDBUser || []).filter(item => {
                const itemText = (item.text || '').toLowerCase();
                const itemEmail = (item.email || '').toLowerCase();
                const matchesFirstName = !searchParams.firstName || itemText.includes(searchParams.firstName.toLowerCase());
                const matchesLastName = !searchParams.lastName || itemText.includes(searchParams.lastName.toLowerCase());
                const matchesEmail = !searchParams.email || itemEmail.includes(searchParams.email.toLowerCase());
                return matchesFirstName && matchesLastName && matchesEmail;
            });

            // Symphony: use local suggestions only; CMC/AD integration commented out below
            const dedupeMap = new Map<string, any>();
            localSuggestions.forEach(item =>
                dedupeMap.set(item.email?.toLowerCase(), { contactName: item.text, contactEmail: item.email })
            );
            this.routesList = Array.from(dedupeMap.values());
            this.handleSearchResults();

            // Prepare API calls for CMC and AD Users (preserved for reference - not used in Symphony) 
            // const cmcRequest = { "soeId": this.soeId, "firstName": searchParams.firstName, "lastName": searchParams.lastName, "contactEmail": searchParams.email, "toCcBcc": (this.popup || '').toUpperCase() };
            
            // QMA-2681 has been created to look into the issue of CMC search not working for Symphony.
            // const cmcPromise = firstValueFrom(this.newMessageService.getContactListFromCMC(cmcRequest)).catch(e => ({ qmaContactList: [] }));
            
            // const adPromise = this.userDataService.getAdSearchUserList(searchParams);
    
            // Run calls and merge all three sources
            // Promise.all([cmcPromise, adPromise]).then(([cmcResult, adUsers]) => {
            //     const dedupeMap = new Map<string, any>();
    
            //     // Add local suggestions first
            //     localSuggestions.forEach(item => dedupeMap.set(item.email.toLowerCase(), { contactName: item.text, contactEmail: item.email }));
    
            //     // Then add CMC results
            //     (cmcResult.qmaContactList || []).forEach(route => {
            //         if (route.email && !dedupeMap.has(route.email.toLowerCase())) {
            //             dedupeMap.set(route.email.toLowerCase(), { contactName: `${route.lastName},${route.firstName}`, contactEmail: route.email, clientName: route.clientName, clientId: route.clientID });
            //         }
            //     });
    
            //     // Finally, add AD users
            //     (adUsers || []).forEach(user => {
            //         const adEmail = user.mail || user.userPrincipalName;
            //         if (adEmail && !dedupeMap.has(adEmail.toLowerCase())) {
            //             dedupeMap.set(adEmail.toLowerCase(), { contactName: user.displayName, contactEmail: adEmail });
            //         }
            //     });
    
            //     this.routesList = Array.from(dedupeMap.values());
            //     this.handleSearchResults();
            // });
        }
        // Group DL Search Logic (Local + Active Directory)
        else if (this.searchByOption === 'GROUP') {
            const groupQuery = this.advancedSearch.groupDL ? this.advancedSearch.groupDL.trim() : '';
    
            if (!groupQuery || groupQuery.length < 3) {
                this.errorMsg = 'Please enter a Group DL name (at least 3 characters).';
                this.showCmcSpinner = false;
                return;
            }
            // Get matching local suggestions for groups from login user info via userDataService. It used to be from "this.allToCcDBUser" but that list only contains users, not groups.
            const allActiveGroups = this.userDataService.getAllActiveGroups?.() ?? this.userDataService.loggedInUserInfo?.allActiveGroups ?? [];

            const localSuggestions = (allActiveGroups || []).filter(
                item => item.text?.toLowerCase().includes(groupQuery.toLowerCase())
            );
            
            // Symphony: use local suggestions only; AD integration commented out below
            const dedupeMap = new Map<string, any>();
            localSuggestions.forEach(item =>
                dedupeMap.set(item.email?.toLowerCase(), { contactName: item.text, contactEmail: item.email })
            );
            this.routesList = Array.from(dedupeMap.values());
            this.handleSearchResults();
            // Get AD Groups and merge results
            // this.userDataService.getAdSearchGroupList({ displayName: groupQuery })
            //     .then(adGroups => {
            //         const dedupeMap = new Map<string, any>();
    
            //         // Add local suggestions first
            //         localSuggestions.forEach(item => dedupeMap.set(item.email.toLowerCase(), { contactName: item.text, contactEmail: item.email }));
                    
            //         // Then add AD groups
            //         (adGroups || []).forEach(group => {
            //             if (group.mail && !dedupeMap.has(group.mail.toLowerCase())) {
            //                 dedupeMap.set(group.mail.toLowerCase(), { contactName: group.displayName, contactEmail: group.mail, department: 'Distribution List' });
            //             }
            //         });
    
            //         this.routesList = Array.from(dedupeMap.values());
            //         this.handleSearchResults();
            //     })
            //     .catch(err => {
            //         this.errorMsg = 'An error occurred while searching for groups.';
            //         this.handleSearchResults();
            //     });
        }
    }

    /* Helper function to handle UI updates after a search.*/
    private handleSearchResults() {
        if (this.routesList.length > 0) {
            this.search = true;
            this.errorMsg = "";
            this.displayError = false;
        } else {
            this.search = false;
            this.errorMsg = "No contacts found!";
            this.displayError = true;
        }
        this.showCmcSpinner = false;
        this.cdRef.detectChanges();
    }

    clearSearch() {
        this.query = '';
        this.filteredItems = []; // Clear the filtered items
        this.filterItem(''); // Trigger the filter with empty string
        this.searchPerformed = false;
    }
}
